import InspectedFirmPage from './InspectedFirmPage-redux';

export default InspectedFirmPage;
